var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('h3',[_vm._v(_vm._s(_vm.tag_line))]),_vm._v(" "),_c('img',{attrs:{"src":require("../assets/1-commitment-swear.jpg")}}),_vm._v(" "),_c('div',{staticClass:"content"}),_vm._v(" "),_c('md-button',{on:{"click":_vm.logout}},[_vm._v("Logout")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b21ee31","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = null
// module chunks = 